"use client";

import AnalyticsTabs from "@/app/components/AnalyticsTabs";
import { Box } from "@mui/material";
import PortfolioComponent from "./components/PortfolioComponent";

/**
 * 投资组合页面主组件
 * 根据用户会员状态显示相应内容
 */
export default function PortfolioPage() {
  return (
    <Box sx={{ bgcolor: "background.default", color: "text.primary", minHeight: "100vh" }}>
      <AnalyticsTabs />
      <PortfolioComponent />
    </Box>
  );
}
